module.exports = __webpack_public_path__ + "static/media/39.2a4e5fb5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/39.jpg
// module id = 408
// module chunks = 0